<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      char pmslink
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageCharPmsLink.card.general')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.id')"
                    :value="config.id"
                    cols="12 6@hd start-1"
                    name="id"
                    disabled />
          <hm-input-toggle :label="$t('admin.interfaces.pageCharPmsLink.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           :disabled="!canEnable"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <pre v-html="hotelSettings.hotel.tenantId" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageCharPmsLink.card.basic')"
            :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
            cols="12 6@desktop"
            rows="3 start-2">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageCharPmsLink.basicEnabled')"
                           v-model="config.basicSettings.enabled"
                           :disabled="!config.enabled"
                           cols="12 6@hd start-1"
                           name="basicEnabled" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.chainId')"
                    v-model="config.basicSettings.chainId"
                    cols="12 6@hd start-1"
                    name="chainId" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.hotelId')"
                    v-model="config.basicSettings.hotelId"
                    cols="12 6@hd start-1"
                    name="hotelId" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.user')"
                    v-model="config.basicSettings.user"
                    cols="12 6@hd start-1"
                    name="user" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.password')"
                    v-model="config.basicSettings.password"
                    type="password"
                    cols="12 6@hd start-1"
                    name="password" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.authToken')"
                    v-model="config.basicSettings.authToken"
                    type="password"
                    cols="12 6@hd start-1"
                    name="authToken" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.baseUrl')"
                    v-model="config.basicSettings.baseUrl"
                    cols="12 6@hd start-1"
                    name="baseUrl" />
          <guest-search v-model="config.basicSettings.unrelatableChargesProfile"
                        :label="$t('admin.interfaces.pageCharPmsLink.unrelatableChargesProfile')"
                        cols="12 6@hd start-1" />
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.call')" cols="12 6@desktop">
          <hm-input-select :label="$t('admin.interfaces.pageCharPmsLink.callIhsId')"
                           v-model="config.basicSettings.callIhsId"
                           cols="12 6@hd start-1"
                           name="callIhsId"
                           no-select>
            <option v-for="item in hotelSettings.inHouseServices.all(config.basicSettings.callIhsId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-money :label="$t('admin.interfaces.pageCharPmsLink.callChargeUnitPrice')"
                          v-model="config.basicSettings.callChargeUnitPrice"
                          :currency="hotelSettings.details.currency"
                          cols="12 6@hd start-1"
                          name="callChargeUnitPrice" />
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.pbxClassOfService')" cols="12 6@desktop">
          <template v-for="(it, idx) in config.basicSettings.pbxClassOfService">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.pbxClassOfServiceItem')"
                      v-model="config.basicSettings.pbxClassOfService[idx]"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.tvClassOfService')" cols="12 6@desktop">
          <template v-for="(it, idx) in config.basicSettings.tvClassOfService">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.tvClassOfServiceItem')"
                      v-model="config.basicSettings.tvClassOfService[idx]"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.hotspotClassOfService')" cols="12 6@desktop">
          <template v-for="(it, idx) in config.basicSettings.hotspotClassOfService">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.hotspotClassOfServiceItem')"
                      v-model="config.basicSettings.hotspotClassOfService[idx]"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.defaultClassOfService')" cols="12 6@desktop">
          <hm-input-select v-model="config.basicSettings.defaultPbxClassOfService"
                           :label="$t('admin.interfaces.pageCharPmsLink.defaultPbxClassOfService')"
                           cols="12 6@hd start-1"
                           no-select>
            <option v-for="it in config.basicSettings.pbxClassOfService"
                    v-if="!isEmpty(it)"
                    :key="it"
                    :value="it"
                    v-html="it" />
          </hm-input-select>
          <hm-input-select v-model="config.basicSettings.defaultTvClassOfService"
                           :label="$t('admin.interfaces.pageCharPmsLink.defaultTvClassOfService')"
                           cols="12 6@hd start-1"
                           no-select>
            <option v-for="it in config.basicSettings.tvClassOfService"
                    v-if="!isEmpty(it)"
                    :key="it"
                    :value="it"
                    v-html="it" />
          </hm-input-select>
          <hm-input-select v-model="config.basicSettings.defaultHotspotClassOfService"
                           :label="$t('admin.interfaces.pageCharPmsLink.defaultHotspotClassOfService')"
                           cols="12 6@hd start-1"
                           no-select>
            <option v-for="it in config.basicSettings.hotspotClassOfService"
                    v-if="!isEmpty(it)"
                    :key="it"
                    :value="it"
                    v-html="it" />
          </hm-input-select>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.services')" cols="12 6@desktop">
          <template v-for="(it, idx) in config.basicSettings.taxCodeToIhsId">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.taxCode')"
                      v-model="it[0]"
                      :key="`${idx}-key`"
                      cols="12 6@hd start-1"
                      name="taxCode" />
            <hm-input-select :label="$t('admin.interfaces.pageCharPmsLink.ihsId')"
                             v-model="it[1]"
                             :key="`${idx}-value`"
                             cols="12 6@hd"
                             name="ihsId"
                             no-select>
              <option v-for="item in hotelSettings.inHouseServices.all(it[1])" :value="item.id" v-html="item.name[$shortLocale]"></option>
            </hm-input-select>
          </template>
        </hm-card-inner>
      </card>

      <card :title="$t('admin.interfaces.pageCharPmsLink.card.keyCard')" cols="12 6@desktop" rows="3">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageCharPmsLink.keyCardEnabled')"
                           v-model="config.keyCardSettings.enabled"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || !config.enabled"
                           cols="12 6@hd start-1"
                           name="keyCardEnabled" />
          <hm-input-toggle v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           :label="$t('admin.interfaces.pageCharPmsLink.mobileKeyEnabled')"
                           v-model="config.keyCardSettings.mobileKeyEnabled"
                           :disabled="!config.enabled"
                           cols="12 6@hd start-1"
                           name="mobileKeyEnabled" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.chainId')"
                    v-model="config.keyCardSettings.chainId"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    cols="12 6@hd start-1"
                    name="chainId" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.hotelId')"
                    v-model="config.keyCardSettings.hotelId"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    cols="12 6@hd start-1"
                    name="hotelId" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.user')"
                    v-model="config.keyCardSettings.user"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    cols="12 6@hd start-1"
                    name="user" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.password')"
                    v-model="config.keyCardSettings.password"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    type="password"
                    cols="12 6@hd start-1"
                    name="password" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.authToken')"
                    v-model="config.keyCardSettings.authToken"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    type="password"
                    cols="12 6@hd start-1"
                    name="authToken" />
          <hm-input :label="$t('admin.interfaces.pageCharPmsLink.keyCardBaseUrl')"
                    v-model="config.keyCardSettings.baseUrl"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    cols="12 6@hd start-1"
                    name="keyCardBaseUrl" />
          <hm-input-number :label="$t('admin.interfaces.pageCharPmsLink.numberOfCards')"
                           v-model="config.keyCardSettings.numberOfCards"
                           cols="12 6@hd start-1"
                           required
                           name="numberOfCards" />
          <hm-input-number :label="$t('admin.interfaces.pageCharPmsLink.encoderWaitSeconds')"
                           v-model="config.keyCardSettings.encoderWaitSeconds"
                           cols="12 6@hd start-1"
                           required
                           name="encoderWaitSeconds" />
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.keyCardEncoders')">
          <template v-for="(it, idx) in config.keyCardSettings.encoders">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.keyCardEncoderItem')"
                      v-model="config.keyCardSettings.encoders[idx]"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.keyCardExtraAccess')">
          <template v-for="(it, idx) in config.keyCardSettings.extraAccess">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.keyCardExtraAccessItem')"
                      v-model="config.keyCardSettings.extraAccess[idx]"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageCharPmsLink.card.keyCardRooms')">
          <hm-input v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    :label="$t('admin.interfaces.pageCharPmsLink.keyCardRoomQuickEntry')"
                    v-model="keyCardRoomQuickEntry"
                    :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    lazy
                    cols="12"
                    @blur="blurQuickEntryRooms" />
          <template v-for="(it, idx) in config.keyCardSettings.rooms">
            <hm-input :label="$t('admin.interfaces.pageCharPmsLink.keyCardRoomItem')"
                      v-model="config.keyCardSettings.rooms[idx]"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      :key="idx"
                      cols="12 6@hd start-1"
                      name="item" />
          </template>
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons v-if="!isNil(config)">
      <hm-floating-button label="Show more" icon="fill-more" color="gray">
        <!-- TODO -->
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, first, groupBy, indexOf, isEmpty, isNil, keyBy, maxBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import HmTextarea from '../../../lib/inputs/HmTextarea.vue';
import AiTextGenerator from '../../../lib/util/AiTextGenerator.vue';
import GuestSearch from '../../../lib/inputs/GuestSearch.vue';
import HmCardInnerLine from '../../../lib/layout/HmCardInnerLine.vue';
import AutoAddNewRowsMixin from '../../../../mixins/AutoAddNewRowsMixin';

export default {
  name: 'PageCharPmsLink',
  components: { HmCardInnerLine, GuestSearch, AiTextGenerator, HmTextarea, HmInputSelect, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, UpdateHotelSettingsMixin, AutoAddNewRowsMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update', // required to update list of encoders, rooms, extra access and encoder timeout seconds
      fn: function (cbSaveComplete) {
        const config = cloneDeep(this.config);

        config.basicSettings.taxCodeToIhsId = Object.fromEntries(config.basicSettings.taxCodeToIhsId.filter(it => !isEmpty(it[0] && !isEmpty(it[1]))));
        config.basicSettings.pbxClassOfService = config.basicSettings.pbxClassOfService.filter(it => !isEmpty(it));
        config.basicSettings.tvClassOfService = config.basicSettings.tvClassOfService.filter(it => !isEmpty(it));
        config.basicSettings.hotspotClassOfService = config.basicSettings.hotspotClassOfService.filter(it => !isEmpty(it));
        config.keyCardSettings.encoders = config.keyCardSettings.encoders.filter(it => !isEmpty(it));
        config.keyCardSettings.rooms = config.keyCardSettings.rooms.filter(it => !isEmpty(it));
        config.keyCardSettings.extraAccess = config.keyCardSettings.extraAccess.filter(it => !isEmpty(it));

        this.axios.put(this.serviceUrls.interfaces.charPmsLink.get(this, this.config.id), config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      keyCardRoomQuickEntry: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    canEnable() {
      if (isNil(this.config)) return false;

      return true;
    },
  },

  watch: {
    'config.basicSettings.pbxClassOfService': {
      handler: function () {
        this.autoAddNewRows(
          this.config.basicSettings.pbxClassOfService,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.basicSettings.hotspotClassOfService': {
      handler: function () {
        this.autoAddNewRows(
          this.config.basicSettings.hotspotClassOfService,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.basicSettings.tvClassOfService': {
      handler: function () {
        this.autoAddNewRows(
          this.config.basicSettings.tvClassOfService,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.basicSettings.taxCodeToIhsId': {
      handler: function () {
        this.autoAddNewRows(
          this.config.basicSettings.taxCodeToIhsId,
          [null, null],
          it => isEmpty(it[0]) && isEmpty(it[1]),
        );
      },
      deep: true,
    },
    'config.keyCardSettings.rooms': {
      handler: function () {
        this.autoAddNewRows(
          this.config.keyCardSettings.rooms,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.keyCardSettings.encoders': {
      handler: function () {
        this.autoAddNewRows(
          this.config.keyCardSettings.encoders,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.keyCardSettings.extraAccess': {
      handler: function () {
        this.autoAddNewRows(
          this.config.keyCardSettings.extraAccess,
          null,
          it => isEmpty(it),
        );
      },
      deep: true,
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    isEmpty,
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.charPmsLink.get(this, this.$route.params.configId))
        .then((response) => {
          const tmp = response.data.data;
          tmp.basicSettings.taxCodeToIhsId = Object.entries(tmp.basicSettings.taxCodeToIhsId);
          this.config = tmp;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    deleteInstance(force = false) {
      if (force) {
        this.axios.delete(this.serviceUrls.interfaces.charPmsLink.delete(this, this.config.id))
          .then((response) => {
            this.showSuccessMessage();
            this.showMessages(response);
            this.$serviceBus.$emit('hotelSettings.update.immediate');
            this.$router.push({ name: 'interfaces' });
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.interfaces.pageCharPmsLink.confirmDelete', [this.hotelSettings.hotel.hotelName]),
          () => this.deleteInstance(true),
          this.$t('admin.interfaces.pageCharPmsLink.confirmDeleteWarning'),
        );
      }
    },
    deleteRecord(parent, it, idx) {
      this.config[parent].splice(idx, 1);
    },
    blurQuickEntryRooms() {
      if (!isEmpty(this.keyCardRoomQuickEntry)) {
        const roomNumbers = this.keyCardRoomQuickEntry.split(',');
        roomNumbers.forEach((it) => {
          if (!isEmpty(it)) {
            const trimmedRoomNumber = it.trim();
            if (!this.config.keyCardSettings.rooms.includes(trimmedRoomNumber)) {
              this.config.keyCardSettings.rooms.push(trimmedRoomNumber);
            }
          }
        });
        this.keyCardRoomQuickEntry = null;
        this.config.keyCardSettings.rooms = this.config.keyCardSettings.rooms.filter(it => !isEmpty(it));
        this.showSuccessMessage();
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageCharPmsLink.vue